module.exports = __webpack_public_path__ + "account-circle.4fc929fd6d5b3779510e.svg";


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/assets/images/account-circle.svg
// module id = ../../../../../src/assets/images/account-circle.svg
// module chunks = styles